module.exports = __webpack_public_path__ + "static/media/ie.38bb1583.svg";